import React from "react";
import { ArrowUpRight, Phone } from "lucide-react";
import { resolveLogoUrl } from "@/lib/media";

function splitHeadline(title) {
  const lines = title?.split("/").map((line) => line.trim()).filter(Boolean);
  return lines?.length ? lines : [title];
}

export default function Hero({ settings, language, mode, onQuote }) {
  const lines = splitHeadline(settings.hero_title?.[language]);
  const logo = resolveLogoUrl(settings, language);
  const phoneHref = `tel:${settings.phone.replace(/[^0-9+]/g, "")}`;

  return (
    <section className="hero" id="top" data-testid="hero-section">
      <div className="hero-grid">
        <div className="hero-copy">
          <span className="eyebrow" data-testid="hero-kicker">{settings.hero_kicker?.[language]}</span>
          <h1 className="hero-headline" data-testid="hero-headline">
            {lines.map((line, index) => <span className="headline-line" key={index}><span>{line}</span></span>)}
          </h1>
          <div className="hero-logo-stage" data-testid="hero-logo-stage">
            <div className="hero-logo-frame"><img className="hero-dynamic-logo" src={logo} alt={`${settings.brand_name} ${language === "en" ? "logo" : "logotipo"}`} data-testid="hero-logo-image" /></div>
            <span className="hero-logo-caption">{language === "en" ? "The Protech mark / in motion" : "La marca Protech / en movimiento"}</span>
          </div>
          <p className="hero-body" data-testid="hero-description">{settings.hero_body?.[language]}</p>
          <div className="hero-actions">
            <button className="button" type="button" onClick={onQuote} data-testid="hero-request-quote-button">
              {settings.hero_primary_label?.[language]} <ArrowUpRight />
            </button>
            <a className="button button-secondary" href={phoneHref} data-testid="hero-emergency-call-button">
              <Phone /> {settings.hero_secondary_label?.[language]}
            </a>
          </div>
          <p className="hero-note" data-testid="hero-service-area">{settings.hero_note?.[language]}</p>
          <div className="hero-stat-row" data-testid="hero-stats">
            <div className="hero-stat"><span className="hero-stat-value">01</span><span className="hero-stat-label">{language === "en" ? "Clear quote" : "Cotización clara"}</span></div>
            <div className="hero-stat"><span className="hero-stat-value">NY</span><span className="hero-stat-label">{language === "en" ? "Local field team" : "Equipo local"}</span></div>
            <div className="hero-stat"><span className="hero-stat-value">24/7</span><span className="hero-stat-label">{language === "en" ? "Comfort mindset" : "Enfoque en confort"}</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
